import Button from "../components/Button/Button";
import React from 'react'
import Navbar from "../components/Navbar/Navbar";
import { LoginButton } from "../components/LoginButton/LoginButton";
import { LogoutButton } from "../components/LogoutButton/LogoutButton";

function Home() {
    return (
        <div>
            <Navbar/>
            <h1>Codex</h1>
            <h3>Donde cada secreto es custodio del silencio eterno, y toda revelación espera su juicio.</h3>



        </div>
    );
}

export default Home;